"use client"

import { useInView } from "react-intersection-observer"
import { Target, Eye, Heart } from "lucide-react"
import "../assets/css/mission-vision.css"

export default function MissionVision() {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  })

  return (
    <section id="about" ref={ref} className="mission-vision-section">
      <div className="mission-container">
        <div className="section-header">
          <h2 className={`mission-title ${inView ? "visible" : ""}`}>Our Foundation</h2>
          <div className={`section-divider ${inView ? "visible" : ""}`}></div>
          <p className={`section-subtitle ${inView ? "visible" : ""}`}>
            Guided by our core principles, we strive to make a positive impact on agriculture and communities
          </p>
        </div>

        <div className="mvv-grid">
          <div className={`mvv-card mission-card ${inView ? "visible" : ""}`} style={{ transitionDelay: "0.3s" }}>
            <div className="mvv-icon">
              <Target className="icon-svg" />
            </div>
            <h3 className="mvv-title">Our Mission</h3>
            <p className="mvv-content">
              To cultivate premium agricultural products through smart, sustainable practices, transform them into
              high-quality value-added goods like sauces, and deliver freshness directly to consumers through an
              innovative vegetable-based supermarket chain—empowering communities and protecting the planet every step
              of the way.
            </p>
          </div>

          <div className={`mvv-card vision-card ${inView ? "visible" : ""}`} style={{ transitionDelay: "0.5s" }}>
            <div className="mvv-icon">
              <Eye className="icon-svg" />
            </div>
            <h3 className="mvv-title">Our Vision</h3>
            <p className="mvv-content">
              To revolutionize agriculture and food systems by leading the world toward smarter, greener, and more
              sustainable farming, production, and retail. Farming smarter. Growing greener. Feeding better.
            </p>
          </div>
        </div>

        <div className="strategic-objectives-container">
          <div className={`mvv-card objectives-card ${inView ? "visible" : ""}`} style={{ transitionDelay: "0.7s" }}>
            <div className="mvv-icon">
              <Heart className="icon-svg" />
            </div>
            <h3 className="mvv-title">Our Strategic Objectives</h3>
            <div className="values-list">
              <div className="value-item">
                <span className="value-bullet"></span>
                <span>
                  <strong>Advance Smart & Sustainable Agriculture:</strong> Implement eco-friendly, semi-greenhouse
                  farming methods that increase productivity and reduce environmental impact.
                </span>
              </div>
              <div className="value-item">
                <span className="value-bullet"></span>
                <span>
                  <strong>Deliver Farm-to-Table Freshness:</strong> Build a robust farm-to-retail pipeline through our
                  vegetable-based supermarket chain for maximum freshness and traceability.
                </span>
              </div>
              <div className="value-item">
                <span className="value-bullet"></span>
                <span>
                  <strong>Launch World-Class Sauce Manufacturing:</strong> Produce premium sauces using sustainably
                  grown ingredients from our own farms, maintaining high standards of quality and food safety.
                </span>
              </div>
              <div className="value-item">
                <span className="value-bullet"></span>
                <span>
                  <strong>Expand Our Product Portfolio:</strong> Diversify offerings to include fresh vegetables,
                  premium grow bags, sauces, and other sustainable agri-solutions.
                </span>
              </div>
              <div className="value-item">
                <span className="value-bullet"></span>
                <span>
                  <strong>Ensure International Quality Standards:</strong> Maintain excellence in cultivation,
                  manufacturing, and retail to meet or exceed global benchmarks.
                </span>
              </div>
              <div className="value-item">
                <span className="value-bullet"></span>
                <span>
                  <strong>Empower Farmers & Uplift Communities:</strong> Support local farming communities through
                  partnerships, training, and inclusive business models.
                </span>
              </div>
              <div className="value-item">
                <span className="value-bullet"></span>
                <span>
                  <strong>Grow Locally & Globally:</strong> Expand our presence both in Sri Lanka through retail and
                  globally through international agricultural trade.
                </span>
              </div>
              <div className="value-item">
                <span className="value-bullet"></span>
                <span>
                  <strong>Drive Innovation Across the Value Chain:</strong> Invest in R&D for continuous improvement in
                  farming, product development, and customer experiences.
                </span>
              </div>
              <div className="value-item">
                <span className="value-bullet"></span>
                <span>
                  <strong>Offer Expert Agricultural Consultation:</strong> Provide professional guidance and after-sales
                  support to optimize productivity and sustainability for clients.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Background decoration */}
      <div className="bg-pattern bg-pattern-1"></div>
      <div className="bg-pattern bg-pattern-2"></div>
    </section>
  )
}
